export const AUTH_TOKEN_TEXT = "SpotieAuthToken";

export const dummyVehicle = {
  id: "c761a3dc-c142-44f3-8345-10c70ecd9c05",
  userId: "68b7df6d-96d3-4409-9381-fab921ccb752",
  name: "Test Vehicle 2",
  make: "Make ",
  type: "standard",
  model: "Model",
  licensePlate: "1234567",
  color: "#C9C18F",
  createdAt: "2025-04-16T13:09:36.799Z",
  updatedAt: "2025-04-16T13:09:36.799Z",
};

export const dummySpot = {
  id: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
  userId: "68b7df6d-96d3-4409-9381-fab921ccb752",
  name: "test again",
  address: "address",
  ratePerHour: "10.00",
  status: "publish",
  location: {
    crs: {
      type: "name",
      properties: {
        name: "EPSG:4326",
      },
    },
    type: "Point",
    coordinates: [72.12575160627325, 21.778640483611284],
  },
  allowedVehicleType: {
    suv: true,
    compact: true,
    standard: true,
  },
  createdAt: "2025-04-17T20:54:45.533Z",
  updatedAt: "2025-04-17T20:54:45.533Z",
  availabilities: [
    {
      id: "4ce5de95-2be0-4fa5-a9f6-acd8478c8e6c",
      spotId: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
      day: "Thu",
      startTime: "09:00AM",
      endTime: "12:00PM",
      createdAt: "2025-04-17T20:54:45.588Z",
      updatedAt: "2025-04-17T20:54:45.588Z",
    },
    {
      id: "b13b188f-3af8-4d3d-a326-eb8b2b1e19db",
      spotId: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
      day: "Fri",
      startTime: "09:00AM",
      endTime: "12:00PM",
      createdAt: "2025-04-17T20:54:45.588Z",
      updatedAt: "2025-04-17T20:54:45.588Z",
    },
    {
      id: "2697efec-a7de-4418-9e3a-3c44f2129ff1",
      spotId: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
      day: "Mon",
      startTime: "09:00AM",
      endTime: "05:00PM",
      createdAt: "2025-04-17T20:54:45.588Z",
      updatedAt: "2025-04-18T11:16:01.573Z",
    },
    {
      id: "bbd1ac5e-6db6-40fa-acab-04d39b859a8f",
      spotId: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
      day: "Wed",
      startTime: "09:00AM",
      endTime: "12:00PM",
      createdAt: "2025-04-17T20:54:45.588Z",
      updatedAt: "2025-04-17T20:54:45.588Z",
    },
  ],
};

export const spotsList = [
  {
    id: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
    userId: "68b7df6d-96d3-4409-9381-fab921ccb752",
    name: "test again",
    address: "address",
    ratePerHour: "10.00",
    status: "publish",
    location: {
      crs: {
        type: "name",
        properties: {
          name: "EPSG:4326",
        },
      },
      type: "Point",
      coordinates: [72.12575160627325, 21.778640483611284],
    },
    allowedVehicleType: {
      suv: true,
      compact: true,
      standard: true,
    },
    createdAt: "2025-04-17T20:54:45.533Z",
    updatedAt: "2025-04-17T20:54:45.533Z",
    availabilities: [
      {
        id: "4ce5de95-2be0-4fa5-a9f6-acd8478c8e6c",
        spotId: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
        day: "Thu",
        startTime: "09:00AM",
        endTime: "12:00PM",
        createdAt: "2025-04-17T20:54:45.588Z",
        updatedAt: "2025-04-17T20:54:45.588Z",
      },
      {
        id: "b13b188f-3af8-4d3d-a326-eb8b2b1e19db",
        spotId: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
        day: "Fri",
        startTime: "09:00AM",
        endTime: "12:00PM",
        createdAt: "2025-04-17T20:54:45.588Z",
        updatedAt: "2025-04-17T20:54:45.588Z",
      },
      {
        id: "2697efec-a7de-4418-9e3a-3c44f2129ff1",
        spotId: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
        day: "Mon",
        startTime: "09:00AM",
        endTime: "05:00PM",
        createdAt: "2025-04-17T20:54:45.588Z",
        updatedAt: "2025-04-18T11:16:01.573Z",
      },
      {
        id: "bbd1ac5e-6db6-40fa-acab-04d39b859a8f",
        spotId: "315908b5-ebfe-493e-8f84-4bde4cb13bbd",
        day: "Wed",
        startTime: "09:00AM",
        endTime: "12:00PM",
        createdAt: "2025-04-17T20:54:45.588Z",
        updatedAt: "2025-04-17T20:54:45.588Z",
      },
    ],
  },
];

export const vehiclesList = [
  {
    id: "c761a3dc-c142-44f3-8345-10c70ecd9c05",
    userId: "68b7df6d-96d3-4409-9381-fab921ccb752",
    name: "Test Vehicle 1",
    make: "Make ",
    type: "compact",
    model: "Model",
    licensePlate: "123",
    color: "#C9C18F",
    createdAt: "2025-04-16T13:09:36.799Z",
    updatedAt: "2025-04-16T13:09:36.799Z",
  },
  {
    id: "c761a3dc-c142-44f3-8345-10c70ecd9c04",
    userId: "68b7df6d-96d3-4409-9381-fab921ccb752",
    name: "Test Vehicle 2",
    make: "Make ",
    type: "standard",
    model: "Model",
    licensePlate: "1234",
    color: "#C9C18F",
    createdAt: "2025-04-16T13:09:36.799Z",
    updatedAt: "2025-04-16T13:09:36.799Z",
  },
  {
    id: "c761a3dc-c142-44f3-8345-10c70ecd9c06",
    userId: "68b7df6d-96d3-4409-9381-fab921ccb752",
    name: "Test Vehicle 3",
    make: "Make ",
    type: "suv",
    model: "Model",
    licensePlate: "1231",
    color: "#C9C18F",
    createdAt: "2025-04-16T13:09:36.799Z",
    updatedAt: "2025-04-16T13:09:36.799Z",
  },
];

export const availableTimes = [
  { start: "08:00" },
  { start: "08:15" },
  { start: "08:30" },
  { start: "08:45" },
  { start: "09:00" },
  { start: "09:15" },
  { start: "09:30" },
  { start: "09:45" },
  { start: "10:00" },
  { start: "10:15" },
  { start: "10:30" },
  { start: "10:45" },
  { start: "11:45" },
  { start: "23:45" },
];

export const timeFilters = [
  { label: "15 Mins", value: "15 minutes" },
  { label: "30 Mins", value: "30 minutes" },
  { label: "1 Hour", value: "1 hour" },
  { label: "2 Hours", value: "2 hours" },
  { label: "3 Hours", value: "3 hours" },
  { label: "4 Hours", value: "4 hours" },
  { label: "5 Hours", value: "5 hours" },
  { label: "6 Hours", value: "6 hours" },
  { label: "7 Hours", value: "7 hours" },
  { label: "8 Hours", value: "8 hours" },
  { label: "9 Hours", value: "9 hours" },
  { label: "10 Hours", value: "10 hours" },
  { label: "11 Hours", value: "11 hours" },
  { label: "12 Hours", value: "12 hours" },
  { label: "13 Hours", value: "13 hours" },
  { label: "14 Hours", value: "14 hours" },
  { label: "15 Hours", value: "15 hours" },
  { label: "16 Hours", value: "16 hours" },
  { label: "17 Hours", value: "17 hours" },
  { label: "18 Hours", value: "18 hours" },
  { label: "19 Hours", value: "19 hours" },
  { label: "20 Hours", value: "20 hours" },
  { label: "21 Hours", value: "21 hours" },
  { label: "22 Hours", value: "22 hours" },
  { label: "23 Hours", value: "23 hours" },
  { label: "24 Hours", value: "24 hours" },
];

export const customTimesFilters = [
  { label: "1 Day", value: "1 day" },
  { label: "2 Days", value: "2 days" },
  { label: "3 Days", value: "3 days" },
  { label: "4 Days", value: "4 days" },
  { label: "5 Days", value: "5 days" },
  { label: "6 Days", value: "6 days" },
  { label: "7 Days", value: "7 days" },
  { label: "8 Days", value: "8 days" },
  { label: "9 Days", value: "9 days" },
  { label: "10 Days", value: "10 days" },
  { label: "11 Days", value: "11 days" },
  { label: "12 Days", value: "12 days" },
  { label: "13 Days", value: "13 days" },
  { label: "14 Days", value: "14 days" },
  { label: "15 Days", value: "15 days" },
  { label: "16 Days", value: "16 days" },
  { label: "17 Days", value: "17 days" },
  { label: "18 Days", value: "18 days" },
  { label: "19 Days", value: "19 days" },
  { label: "20 Days", value: "20 days" },
  { label: "21 Days", value: "21 days" },
  { label: "22 Days", value: "22 days" },
  { label: "23 Days", value: "23 days" },
  { label: "24 Days", value: "24 days" },
  { label: "25 Days", value: "25 days" },
  { label: "26 Days", value: "26 days" },
  { label: "27 Days", value: "27 days" },
  { label: "28 Days", value: "28 days" },
  { label: "29 Days", value: "29 days" },
  { label: "30 Days", value: "30 days" },
];

export const defaultAvailability = [
  {
    day: "Sun",
    hours: [],
  },
  {
    day: "Mon",
    hours: [],
  },
  {
    day: "Tue",
    hours: [],
  },
  {
    day: "Wed",
    hours: [],
  },
  {
    day: "Thu",
    hours: [],
  },
  {
    day: "Fri",
    hours: [],
  },
  {
    day: "Sat",
    hours: [],
  },
];
